import React from "react";

import { useRegisterFormContext } from "@pages/register/hooks/useRegisterFormContext";
import { FinanceContactInformationForm } from "@pages/register/steps/UserDetails/FinanceContactInformationForm";

export const FinanceContactInformation = () => {
  const { control, errors } = useRegisterFormContext();

  return <FinanceContactInformationForm control={control} errors={errors} />;
};
